webpackJsonp([273950069227526],{

/***/ 352:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>We solve [your] problems with technology.</p>","frontmatter":{"title":null}}},"pathContext":{"id":"/opt/build/repo/src/pages/about/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---about-01b2a5d9f961d8a7cbde.js